import type { PageInstanceSummary } from "@octopusdeploy/portal-routes";
import { PageInstanceSummaryProvider } from "@octopusdeploy/portal-routes";
import type React from "react";
import { useCallback, useEffect, useState } from "react";
import { currentPageContext } from "~/openTelemetry/context/currentPageContext";
import type { PageArea } from "~/routing/PageAreaContext";
import { PageAreaProvider } from "~/routing/PageAreaContext";
import type { GlobalPageDetails } from "~/routing/UpdateGlobalPageDetailsContext";
import { UpdateGlobalPageDetailsProvider } from "~/routing/UpdateGlobalPageDetailsContext";
import { setPageForOperationTimer } from "~/utils/OperationTimer/timeOperation";
interface GlobalPageProviderProps {
    children: React.ReactNode;
}
export function GlobalPageProvider({ children }: GlobalPageProviderProps) {
    const [currentPage, setCurrentPage] = useState<PageInstanceSummary | undefined>(undefined);
    const [pageArea, setPageArea] = useState<PageArea | undefined>();
    const updateGlobalPageDetailsCallback = useCallback(({ pageId, pageInstanceId, routeParams, routeTemplate, owner, pageArea }: GlobalPageDetails) => {
        setCurrentPage({ Id: pageId, Area: pageArea.mainArea, instanceId: pageInstanceId, routeParams, routeTemplate, owner });
        setPageArea(pageArea);
    }, []);
    useEffect(() => {
        if (currentPage !== undefined) {
            currentPageContext.setPage(currentPage);
            setPageForOperationTimer(currentPage);
        }
    }, [currentPage]);
    return (<PageInstanceSummaryProvider page={currentPage}>
            <PageAreaProvider value={pageArea}>
                <UpdateGlobalPageDetailsProvider value={updateGlobalPageDetailsCallback}>{children}</UpdateGlobalPageDetailsProvider>
            </PageAreaProvider>
        </PageInstanceSummaryProvider>);
}
